export const APP_VERSION = "v1.1.7";
export const is_dev_env = false; //Change Only Here (True for Local & False for Live)
const LIVE_URL = "https://liveapi.arbitfx.com";
const LOCAL_URL = " http://192.168.1.9:3200";
const UAT_URL = "https://arbitfxuat.algodeltafx.com";
const BASE_URL = is_dev_env ? LIVE_URL : LIVE_URL;
export const API_URL = BASE_URL + "/api/v1";
export const PACKAGE_IMAGE_URL = BASE_URL + "/packages/";
export const USER_PROFILE_PATH = BASE_URL + "/user_profiles/";
export const KYC_DOCS_PATH = BASE_URL + "/kyc_docs/";
export const KYC_IMAGE_PATH = BASE_URL + "/user_kycs/";
export const CLUB_IMAGE_PATH = BASE_URL + "/clubs/";
export const REWARDS_IMAGE_PATH = BASE_URL + "/rewards/";
export const LEVEL_IMAGE_PATH = BASE_URL + "/levels/";
export const TICKETS_IMAGE_PATH = BASE_URL + "/tickets/";
export const SUPPORT_CHAT_IMAGE_PATH = BASE_URL + "/support_chat";
export const NO_REWARD_IMAGE = require("../../src/assets/images/no_reward.png");
export const ANNOUNCEMENT_PATH = BASE_URL + "/announcements/";
export const POPUP_PATH = BASE_URL + "/pop_ups/";
export const DOCUMENT_PATH = BASE_URL + "/documents/";
export const ID_PASSPORT_DOCUMENT_GUIDELINES = [
    "* Fields are compulsory",
    "National ID card (all sides must be scanned into a single file)",
    "National Passport",
    "International Passport",
    "Driving Licenses",
    "Important: The entire page of the identity document must be scanned.",
];

export const PROOF_OF_ADDRESS_DOCUMENT_GUIDELINES = [
    "* Fields are compulsory",
    "Utility bills (e.g., electricity, gas, water, waste) dated within the last 3 months",
    "Bank-issued document dated within the last 3 months.",
    "Most recent document issued by a Municipality, Government Agency, or Tax Authorities",
    "Unexpired National ID Card or Passport showing both the main identity page and the address page in a single file.",
    "Other government-issued documents displaying your name and detailed address (Examples of accepted, unexpired documents: Residence permits, Driving licenses, Voter ID cards, National/Municipal Residential Agencies or Registers)",
];
// Frontend SIDE Beta : "https://arbitfx.algodeltafx.com/" UAT : "https://userv1.arbitfx.com"